import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { AbstractPerformanceRequirementProof } from './abstract-performance-requirement-proof.model';

export class MilestonePerformanceRequirementProof extends AbstractPerformanceRequirementProof {
	milestone_name: string;
	@Transform(dateTransformer)
	date: Date;
	notes: string;
	proof: string;
}
